"use client";
import { Button } from "@/components/ui/Button";
import { Calendar } from "@/components/ui/Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/Popover";
import { formatDateOnly, fromLocalCalendarDate, toLocalCalendarDate } from "@/utils/date-only";
import { Calendar as CalendarIcon } from "lucide-react";
import * as React from "react";
import cn from "twsx";

export type DatePickerProps = {
  date?: Date;
  onSelect?: (date: Date | undefined) => void;
  className?: string;
};

/** Use when a person picks a single date from a calendar. */
export function DatePicker({ date, onSelect, className }: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="secondary"
          className={cn(
            "w-full justify-start text-left font-normal",
            !date && "text-text-tertiary",
            className,
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? formatDateOnly(date, "en-US", { month: "long" }) : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date ? toLocalCalendarDate(date) : undefined}
          onSelect={value => onSelect?.(value ? fromLocalCalendarDate(value) : undefined)}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
